import * as React from "react";

function SvgServerInstallDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M17 12.25a4.754 4.754 0 014.75 4.768l-.006.218A4.75 4.75 0 0117 21.75H7a4.754 4.754 0 01-4.75-4.768l.006-.218A4.75 4.75 0 017 12.25zm-5-1.5a.847.847 0 01-.113-.008l-.035-.007c-.025-.005-.05-.01-.074-.018l-.032-.011c-.025-.009-.05-.02-.073-.03l-.032-.017a.948.948 0 01-.075-.047l-.012-.01a.617.617 0 01-.084-.072l-3-3a.749.749 0 01.976-1.133l.084.073 1.72 1.719V3a.75.75 0 011.493-.102L12.75 3v5.189l1.72-1.72a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-3 3a.606.606 0 01-.081.071l.081-.07a.77.77 0 01-.182.133l-.026.014a.993.993 0 01-.09.036l-.008.002-.025.007a.724.724 0 01-.199.027z"
        />
        <path
          fill="#98DB69"
          d="M17 13.75A3.25 3.25 0 0120.25 17l-.005.181c-.084 1.707-1.51 3.069-3.245 3.069H7A3.25 3.25 0 013.75 17l.005-.181C3.839 15.112 5.265 13.75 7 13.75h10zm-9.593 2.561a.8.8 0 10.158 1.255l.078-.09a.8.8 0 00.062-.854l-.056-.088-.084-.1-.068-.061zM17 16.25h-6l-.102.007A.75.75 0 0011 17.75h6l.102-.007A.75.75 0 0017 16.25z"
        />
      </g>
    </svg>
  );
}

export default SvgServerInstallDuo;
